<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M17 7L7 17M7 7L17 17"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
